import { useEffect, useState } from "react";
import InputText from "../InputText";
import "./editForm.css";
import Button from "../Button";
import instance from "../../api/axios";
import { createUser } from "../../api/route";
import { useNavigate } from "react-router-dom";
import crossIcon from "../../assets/images/cross.png";

const EditFormModel = ({ setopenEditModel }) => {

  const [formData, setFormData] = useState({
    user_name: "",
    user_phone: "",
    city: "",
    pinCode: "",
    fees: "",
    pain_condition: "",
  });
  const [buttonDisabled, setButtonDisabled] = useState(true);

  const handleInputChange = (name, value) => {
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  useEffect(() => {
    const userDetail = sessionStorage.getItem("user");
    const user = JSON.parse(userDetail);
    setFormData({
      user_name: user.name,
      city: user.address,
      pinCode: user.pinCode,
      user_phone: user.phone,
      pain_condition: user.pain_condition || "",
    });
  }, []);

  useEffect(() => {
    setButtonDisabled(
      formData.pinCode.trim() === "" ||
      formData.user_name.trim() === "" ||
      formData.user_phone.trim() === ""
    );
  }, [formData]);

  const handleSubmit = async () => {
    const obj = {
      name: formData.user_name,
      address: formData.city,
      pinCode: formData.pinCode,
      phone: formData.user_phone,
      user_condition: formData.pain_condition,
    };

    try {
      const response = await instance.post(createUser, obj);
      console.log(response.data);

      obj.fees = formData?.fees;
      obj.pain_condition = formData?.pain_condition;
      sessionStorage.setItem("user", JSON.stringify(obj));
      setopenEditModel(false);
      window.location.reload();
    } catch (error) {
      console.error("Error submitting data:", error);
    }
  };
  return (
    <div className="EditFormModelContainer">
      <div className="EditFormModelWrapper">
        <div
          className="flex justify-end px-2 py-2 cursor-pointer"
          onClick={() => setopenEditModel(false)}
        >
          <img
            src={crossIcon}
            alt="Close"
            width={18}
            height={18}
            className="object-contain"
          />
        </div>
        <div className="EditFormModelHeading">
          <h3>Edit Your Information</h3>
        </div>
        <div className="EditFormModelFormWrapper">
          <div className="EditFormModelForm">
            <InputText
              value={formData.user_name}
              name="user_name"
              label="Name"
              placeholder="Enter Your Name"
              onChange={(e) => handleInputChange("user_name", e.target.value)}
            />
            <InputText
              value={formData.user_phone}
              name="user_phone"
              label="Mobile Number"
              placeholder="Enter Your Mobile Number"
              onChange={(e) => handleInputChange("user_phone", e.target.value)}
            />
            <InputText
              name="pinCode"
              value={formData.pinCode}
              label="Pin Code"
              placeholder="Enter Your Pin Code"
              onChange={(e) => handleInputChange("pinCode", e.target.value)}
            />
            {formData?.pinCode === "111111" && (
              <InputText
                name="fees"
                value={formData.fees}
                label="Fees"
                placeholder="Enter Fees"
                onChange={(e) => handleInputChange("fees", e.target.value)}
              />
            )}
            <InputText
              name="pain_condition"
              value={formData.pain_condition}
              label="Pain Condition"
              placeholder="e.g. Knee pain, back pain, etc."
              onChange={(e) => handleInputChange("pain_condition", e.target.value)}
            />

          </div>
          <div className="flex justify-center mt-8">
            <Button
              onClick={handleSubmit}
              btnName="Continue"
              className="offer-gradient text-center text-white font-semibold text-lg px-24 py-2 my-4 rounded-xl"
              disabled={buttonDisabled}
            />

          </div>
        </div>
      </div>
    </div>
  );
};

export default EditFormModel;
